module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal__content modal__content--max p20 pt30"
  }, [_c('h3', {
    staticClass: "text-medium text-uppercase text-size-16 text-left text-height-12 mb15 text-center-xs-down"
  }, [_vm._v("project notes:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.clientCharacterNotes),
      expression: "clientCharacterNotes"
    }],
    staticClass: "mb20 form-control form-control--no-resize form-control--placeholder-gray form-control--notes",
    attrs: {
      "type": "text",
      "placeholder": _vm.clientCharacterNotes
    },
    domProps: {
      "value": (_vm.clientCharacterNotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.clientCharacterNotes = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn--block text-uppercase",
    on: {
      "click": function($event) {
        return _vm.editNotes()
      }
    }
  }, [_vm._v("Save")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ef44e7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/project/modals/ClientCharacterNotes.vue
// module id = 433
// module chunks = 2